import { RouteAnimationShared } from './../../utils/route-animation-shared';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
})
export class IntroComponent implements OnInit {
  SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
  currentIndex = 1;

  returnUrl: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routeAnimationShared: RouteAnimationShared
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  ngOnInit() {}

  swipe(action: string = this.SWIPE_ACTION.RIGHT) {
    // next
    if (action === this.SWIPE_ACTION.RIGHT) {
      this.nextPage();
    }

    // previous
    if (action === this.SWIPE_ACTION.LEFT) {
      this.previousPage();
    }
  }

  nextPage() {
    if (this.currentIndex < 3) {
      this.animatePages(
        (this.currentIndex + 1).toString() + 'Page',
        this.currentIndex.toString() + 'Page',
        true
      );
      this.currentIndex++;
    } else {
      this.goToApp();
    }
  }

  previousPage() {
    if (this.currentIndex > 1) {
      this.animatePages(
        (this.currentIndex - 1).toString() + 'Page',
        this.currentIndex.toString() + 'Page',
        false
      );
      this.currentIndex--;
    }
  }

  animatePages(enter: string, leave: string, isForward: boolean) {
    if (isForward) {
      document.getElementById(leave).style.right = '-100%';
    } else {
      document.getElementById(leave).style.right = '100%';
    }
    document.getElementById(enter).style.right = '0%';
  }

  goToApp() {
    this.routeAnimationShared.showRouteAnimation();
    if (this.returnUrl) {
      this.router.navigate(['/authentication1'], {
        queryParams: { returnUrl: this.returnUrl },
      });
    } else {
      this.router.navigate(['/authentication1']);
    }
  }
}
